import { useLocation } from "react-router-dom";
import { isReaderRoute } from "../utils/isReaderRoute";

export function useIsInReader() {
  const location = useLocation();
  return isReaderRoute(location.pathname);
}
